import { render } from "./EmailCard.vue?vue&type=template&id=25c5cd50&ts=true"
import script from "./EmailCard.vue?vue&type=script&lang=ts"
export * from "./EmailCard.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/my-pages-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__